import { render, staticRenderFns } from "./AutoInfracao.vue?vue&type=template&id=623706f0"
import script from "./AutoInfracao.vue?vue&type=script&lang=js"
export * from "./AutoInfracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports